module.exports = __webpack_public_path__ + "media/images/gifts/cook/sug_cozinhar_3-87d66753e193fc9b4100fdafe6289fa8.jpg";